import { GET_SEO_INFORMATION, PageName } from '@whitbread-eos/api';
import { useCustomLocale, useQueryRequest } from '@whitbread-eos/utils';
import Seo from './SEO.component';
import { jsx as _jsx } from "react/jsx-runtime";
export default function SEOContainer(_ref) {
  var page = _ref.page,
    hotelId = _ref.hotelId,
    bookingFlowId = _ref.bookingFlowId,
    displayMeta = _ref.displayMeta,
    dlpData = _ref.dlpData,
    breadcrumbs = _ref.breadcrumbs,
    tripAdvisorReviews = _ref.tripAdvisorReviews,
    hotelsList = _ref.hotelsList,
    hotel = _ref.hotel,
    _ref$noIndexNoFollow = _ref.noIndexNoFollow,
    noIndexNoFollow = _ref$noIndexNoFollow === void 0 ? false : _ref$noIndexNoFollow,
    destinationCoordinates = _ref.destinationCoordinates,
    countryCodeISO = _ref.countryCodeISO,
    hotelAvailability = _ref.hotelAvailability,
    roomTypeInformation = _ref.roomTypeInformation;
  var _useCustomLocale = useCustomLocale(),
    language = _useCustomLocale.language,
    country = _useCustomLocale.country;
  var queryKey = ['seoInformation', language, country, page];
  var queryParams = {
    language,
    country,
    page
  };
  if (hotelId) {
    queryKey.push(hotelId);
    queryParams['hotelId'] = hotelId;
  }
  if (bookingFlowId) {
    queryKey.push(bookingFlowId);
    queryParams['bookingFlowId'] = bookingFlowId;
  }
  var _useQueryRequest = useQueryRequest(queryKey, GET_SEO_INFORMATION, queryParams, {
      enabled: page !== PageName.DLP
    }),
    data = _useQueryRequest.data,
    isLoading = _useQueryRequest.isLoading,
    isError = _useQueryRequest.isError,
    error = _useQueryRequest.error;
  var _ref2 = data || {},
    _ref2$seoInformation = _ref2.seoInformation,
    seoInformation = _ref2$seoInformation === void 0 ? {} : _ref2$seoInformation;
  if (page === PageName.DLP && dlpData && breadcrumbs) {
    return _jsx(Seo, {
      data: dlpData,
      breadcrumbs: breadcrumbs,
      hotelsList: hotelsList,
      showBreadcrumbs: true,
      isLoading: false,
      isError: false,
      displayMeta: true,
      noIndexNoFollow: noIndexNoFollow,
      destinationCoordinates: destinationCoordinates,
      countryCodeISO: countryCodeISO
    });
  }
  if (page === PageName.HDP && breadcrumbs !== null && breadcrumbs !== void 0 && breadcrumbs.length) {
    return _jsx(Seo, {
      data: seoInformation,
      isLoading,
      isError,
      error,
      displayMeta,
      breadcrumbs,
      tripAdvisorReviews,
      hotel,
      hotelAvailability,
      roomTypeInformation
    });
  }
  if (page === PageName.SRP) {
    return _jsx(Seo, {
      data: seoInformation,
      isLoading,
      isError,
      error,
      displayMeta,
      noIndexNoFollow
    });
  }
  return _jsx(Seo, {
    data: seoInformation,
    isLoading,
    isError,
    error,
    displayMeta
  });
}